const title = 'Simulated Implementation of Dynamic Camera Relocalization Paper';
const description = `An implementation of Feng et al.’s paper *6D Dynamic Camera Relocalization from Single Reference Image* for ENGN 2560: Computer Vision`;

export default {
  title,
  description,
  href: 'https://github.com/dcharatan/dcr-reimplementation',
};
